import { staticTable } from "@-/dev.improve.haniverse.database.schemas.static._lib.table";
import { bool, index, integer } from "@-/dev.improve.haniverse.lib.database.table";
import { graphemeTable } from "@-/dev.improve.haniverse.database.schemas.static.schema._tables.grapheme";

/**
 * Hong Kong list metadata for a grapheme. Sourced from the Hong Kong list of graphemes of
 * commonly-used Chinese characters (`list-of-graphemes-of-commonly-used-chinese-characters`).
 */
export const graphemeHkDataTable = staticTable(
  "grapheme_hk_data",
  {
    graphemeId: integer("grapheme_id")
      .notNull()
      .references(() => graphemeTable.id),

    /** Whether this grapheme appears on the HK "commonly used" list. */
    inCommonlyUsedList: bool("in_commonly_used_list").notNull(),
  },
  (table) => [index("grapheme_hk_data_grapheme_id_idx").on(table.graphemeId)],
);

export type GraphemeHkData = typeof graphemeHkDataTable.$inferSelect;
